<template>
  <ShieldExclamationIcon class="text-brand-red w-12 h-12 mx-auto my-5" />
  <h2 class="text-xl font-semibold py-5 text-center">Experian couldn't verify your identity</h2>
  <p v-if="context === 'applicant'" class="text-center">
    Please continue and submit your payment, then send us an email at
    <a class="text-brand-green hover:underline" :mailto="supportEmail"> {{ supportEmail }}</a>
    to verify your account for credit reports.
  </p>
  <div class="flex mx-auto md:w-1/3 py-5">
    <PrimaryButton @click="navigate">{{
      context === "applicant" || currentRoute.includes("flow") ? "Continue" : "Return to dashboard"
    }}</PrimaryButton>
  </div>
</template>
<script>
import { ShieldExclamationIcon } from "@heroicons/vue/outline"
import { mapGetters } from "vuex"

export default {
  components: {
    ShieldExclamationIcon
  },
  props: {
    context: {
      type: String,
      default: "landlord"
    }
  },
  computed: {
    ...mapGetters(["getCurrentApplication"]),
    currentRoute() {
      return this.$route.name
    }
  },
  methods: {
    navigate() {
      if (this.context === "applicant") {
        if (this.getCurrentApplication.need_applicant_finicity_bank_connection) {
          this.$router.push({
            name: "apply_verify_income",
            params: { id: this.$route.params.id }
          })
        } else {
          if (this.getCurrentApplication.is_paid) {
            // if (!this.getCurrentApplication.applicant.affiliate_offer_optin) {
            //   this.$router.push({
            //     name: "apply_affiliate_optin",
            //     params: { id: this.getCurrentApplication.id }
            //   })
            // } else {
            //   this.$router.push({
            //     name: "apply_complete",
            //     params: { id: this.$route.params.id }
            //   })
            // }

            this.$router.push({
              name: "apply_complete",
              params: { id: this.$route.params.id }
            })
          } else {
            this.$router.push({
              name: "apply_pay",
              params: { id: this.$route.params.id }
            })
          }
        }
      } else {
        if (this.$route.name.includes("flow")) {
          const currentStepIndx = this.$route.meta.steps.findIndex(
            (step) => step.completeRoutes && step.completeRoutes.includes(this.$route.name)
          )
          this.$router.push({ name: this.$route.meta.steps[currentStepIndx + 1].routes[0] })
        } else {
          this.$router.push({ name: "dashboard_forms" })
        }
      }
    }
  }
}
</script>
